import React from "react";
import WorldMapWithMarkers from "../utils/WorldMapMarkers";
import "./Company.css";

function Company() {
  const markers = [
    {
      link: "http://www.imss.nl/",
      showListName:
        '<span style="color:#457B9D"><b>International</b></span> Mass Spectrometry Foundation</a>',
      coords: [80, 0],
      name: "International Mass Spectrometry Foundation",
    },
    {
      link: "http://www.asms.org/",
      showListName:
        '<span style="color:#457B9D"><b>American</b></span> Society for Mass Spectrometry</a>',
      coords: [37.0902, -95.7129],
      name: "American Society for Mass Spectrometry",
    },
    {
      link: "http://saemcaem.qo.fcen.uba.ar/",
      showListName:
        '<span style="color:#457B9D"><b>Argentinian</b></span> Society for Mass Spectrometry</a>',
      coords: [-38.4161, -63.6167],
      name: "Argentinian Society for Mass Spectrometry",
    },
    {
      link: "http://www.anzsms.org/",
      showListName:
        '<span style="color:#457B9D"><b>Australian and New Zealand</b></span> Society for Mass Spectrometry</a>',
      coords: [-25.2744, 133.7751],
      name: "Australian and New Zealand Society for Mass Spectrometry",
    },
    {
      link: "http://www.bsms.be",
      showListName:
        '<span style="color:#457B9D"><b>Belgian</b></span> Society for Mass Spectrometry</a>',
      coords: [50.5039, 4.4699],
      name: "Belgian Society for Mass Spectrometry",
    },
    {
      link: "http://www.brmass.com",
      showListName:
        '<span style="color:#457B9D"><b>Brazilian </b></span> Society for Mass Spectrometry</a>',
      coords: [-14.235, -51.9253],
      name: "Brazilian Society for Mass Spectrometry",
    },
    {
      link: "http://www.bmss.org.uk/",
      showListName:
        '<span style="color:#457B9D"><b>British</b></span> Mass Spectrometry Society</a>',
      coords: [55.3781, -3.436],
      name: "British Mass Spectrometry Society",
    },
    {
      link: "http://www.csms-scsm.ca/",
      showListName:
        '<span style="color:#457B9D"><b>Canadian</b></span> Society for Mass Spectrometry</a>',
      coords: [56.1304, -106.3468],
      name: "Canadian Society for Mass Spectrometry",
    },
    {
      link: "http://www.cmss.org.cn/",
      showListName:
        '<span style="color:#457B9D"><b>Chinese</b></span> Mass Spectrometry Society (Chinese)</a>',
      coords: [35.8617, 104.1954],
      name: "Chinese Mass Spectrometry Society (Chinese)",
    },
    {
      link: "http://www.spektroskopie.cz/en/",
      showListName:
        '<span style="color:#457B9D"><b>Czech Republic</b></span> - Ioannes Marcus Marci Spectroscopic Society</a>',
      coords: [49.8175, 15.473],
      name: "Czech Republic - Ioannes Marcus Marci Spectroscopic Society",
    },
    {
      link: "http://www.dsms.dk/",
      showListName:
        '<span style="color:#457B9D"><b>Danish </b></span> Society for Mass Spectrometry</a>',
      coords: [56.2639, 9.5018],
      name: "Danish Society for Mass Spectrometry",
    },
    {
      link: "http://www.nvms.nl/",
      showListName:
        '<span style="color:#457B9D"><b>Dutch</b></span> Society for Mass Spectrometry</a>',
      coords: [52.1326, 5.2913],
      name: "Dutch Society for Mass Spectrometry",
    },
    {
      link: "http://www.fmss.fi/index.html",
      showListName:
        '<span style="color:#457B9D"><b>Finnish</b></span> Society for Mass Spectrometry</a>',
      coords: [61.9241, 25.7482],
      name: "Finnish Society for Mass Spectrometry",
    },
    {
      link: "https://www.sfsm.fr",
      showListName:
        'Société <span style="color:#457B9D"><b>Française</b></span> de Spectrométrie de Masse</a}',
      coords: [46.6034, 1.8883],
      name: "Société Française de Spectrométrie de Masse",
    },
    {
      link: "http://www.dgms-online.de/",
      showListName:
        '<span style="color:#457B9D"><b>German</b></span> Society for Mass Spectrometry</a>',
      coords: [51.1657, 10.4515],
      name: "German Society for Mass Spectrometry",
    },
    {
      link: "http://www.hmss.gr/gr/index.php",
      showListName:
        '<span style="color:#457B9D"><b>Hellenic</b></span> Mass Spectrometry Society</a>',
      coords: [39.0742, 21.8243],
      name: "Hellenic Mass Spectrometry Society",
    },
    {
      link: "http://www.medicine.org.hk/hksms",
      showListName:
        '<span style="color:#457B9D"><b>Hong Kong</b></span> Society of Mass Spectrometry</a>',
      coords: [22.3193, 114.1694],
      name: "Hong Kong Society of Mass Spectrometry",
    },
    {
      link: "http://www.ksms.org/",
      showListName:
        '<span style="color:#457B9D"><b>Korean</b></span> Society for Mass Spectrometry</a>',
      coords: [35.9078, 127.7669],
      name: "Korean Society for Mass Spectrometry",
    },
    {
      link: "http://www.ismas.org/",
      showListName:
        '<span style="color:#457B9D"><b>Indian</b></span> Society for Mass Spectrometry</a>',
      coords: [20.5937, 78.9629],
      name: "Indian Society for Mass Spectrometry",
    },
    {
      link: "http://www.imss.ie/",
      showListName:
        'The <span style="color:#457B9D"><b>Irish</b></span> Mass Spectrometry Society</a>',
      coords: [53.4129, -8.2439],
      name: "The Irish Mass Spectrometry Society",
    },
    {
      link: "http://www.weizmann.ac.il/ISMS/",
      showListName:
        'The <span style="color:#457B9D"><b>Israeli</b></span> Mass Spectrometry Society</a>',
      coords: [31.0461, 34.8516],
      name: "The Israeli Mass Spectrometry Society",
    },
    {
      link: "http://www.mssj.jp/",
      showListName:
        'Mass Spectrometry Society of <span style="color:#457B9D"><b>Japan</b></span></a>',
      coords: [36.2048, 138.2529],
      name: "Mass Spectrometry Society of Japan",
    },
    {
      link: "http://www.nsms.no/",
      showListName:
        '<span style="color:#457B9D"><b>Norwegian</b></span> Society for Mass Spectrometry</a>',
      coords: [60.472, 8.4689],
      name: "Norwegian Society for Mass Spectrometry",
    },
    {
      link: "http://ptsm.ibch.poznan.pl/",
      showListName:
        '<span style="color:#457B9D"><b>Polish</b></span> Mass Spectrometry Society</a>',
      coords: [51.9194, 19.1451],
      name: "Polish Mass Spectrometry Society",
    },
    {
      link: "https://www.itim-cj.ro/srms/",
      showListName:
        '<span style="color:#457B9D"><b>Romanian </b></span> Society for Mass Spectrometry</a>',
      coords: [45.9432, 24.9668],
      name: "Romanian Society for Mass Spectrometry",
    },
    {
      link: "http://www.vmso.ru/en/",
      showListName:
        '<span style="color:#457B9D"><b>Russian</b></span> Society for Mass Spectrometry</a>',
      coords: [61.524, 105.3188],
      name: "Russian Society for Mass Spectrometry",
    },
    {
      link: "https://www.ssms.org.sg",
      showListName:
        'The <span style="color:#457B9D"><b>Singapore</b></span> Society for Mass Spectrometry</a>',
      coords: [1.3521, 103.8198],
      name: "The Singapore Society for Mass Spectrometry",
    },
    {
      link: "https://saams.org.za",
      showListName:
        '<span style="color:#457B9D"><b>South Africa</b></span> Association for Mass Spectrometry</a>',
      coords: [-30.5595, 22.9375],
      name: "South Africa Association for Mass Spectrometry",
    },
    {
      link: "http://www.e-seem.org",
      showListName:
        '<span style="color:#457B9D"><b>Spanish</b></span> Society for Mass Spectrometry</a>',
      coords: [40.4637, -3.7492],
      name: "Spanish Society for Mass Spectrometry",
    },
    {
      link: "https://kemisamfundet.se/sektioner/svenska-masspektrometrisallskapet-smss/",
      showListName:
        '<span style="color:#457B9D"><b>Swedish</b></span> Mass Spectrometry Society</a>',
      coords: [60.1282, 18.6435],
      name: "Swedish Mass Spectrometry Society",
    },
    {
      link: "http://www.sgms.ch",
      showListName:
        '<span style="color:#457B9D"><b>Swiss</b></span> Group for Mass Spectrometry</a>',
      coords: [46.8182, 8.2275],
      name: "Swiss Group for Mass Spectrometry",
    },
    {
      link: "http://www.tsms.org.tw/",
      showListName:
        '<span style="color:#457B9D"><b>Taiwan</b></span> Society for Mass Spectrometry</a>',
      coords: [23.6978, 120.9605],
      name: "Taiwan Society for Mass Spectrometry",
    },
    {
      link: "http://www.ms.unige.ch",
      showListName:
        '<span style="color:#457B9D"><b>MS @ Romandie</b></span>, new site for the Lake Geneva Area in Switzerland</a>',
      coords: [46.2044, 6.1432],
      name: "MS @ Romandie, new site for the Lake Geneva Area in Switzerland",
    },
  ];

  const viewListMarkers = (
    <div className="view-list-markers">
      {markers.map((marker) => (
        <div
          key={marker.link} // Chiave univoca
          className="view-list-marker" // Classe per il marker
          onClick={() => window.open(marker.link, "_blank")} // Apre il link in una nuova scheda
          dangerouslySetInnerHTML={{
            __html: marker["showListName"],
          }}
        ></div>
      ))}
    </div>
  );


  const title = "Società di Spettrometria di Massa"

  /*
  return (
    <>
      <h2 style={{textAlign: 'center', color: "#003366"}}>{title.toUpperCase()}</h2>
      <div style={{ width: "100%", display: "flex", color: "#2C2C2C" }}>
        <div style={{ width: "50%", padding: "10px" }}>
          <WorldMapWithMarkers markers={markers} />
        </div>
        <div style={{ width: "50%", padding: "20px" }}>{viewListMarkers}</div>
      </div>
    </>
  );
  */
  return (
    <>
      <h2 style={{ textAlign: 'center', color: "#003366" }}>{title.toUpperCase()}</h2>
      <div
        style={{
          width: "100%",
          display: "flex",
          flexWrap: "wrap", // Permette di andare a capo se necessario
          color: "#2C2C2C",
        }}
      >
        <div
          style={{
            width: "50%", // Larghezza predefinita
            padding: "10px",
            minWidth: "350px", // Larghezza minima per evitare che diventi troppo stretto
          }}
        >
          <WorldMapWithMarkers markers={markers} />
        </div>
        <div
          style={{
            width: "50%",
            padding: "20px",
            minWidth: "350px", // Larghezza minima per il contenuto
          }}
        >
          {viewListMarkers}
        </div>
      </div>
    </>
  );
  
}

export default Company;
